import { render, staticRenderFns } from "./AwardBanner.vue?vue&type=template&id=6f94df5c&"
import script from "./AwardBanner.vue?vue&type=script&lang=js&"
export * from "./AwardBanner.vue?vue&type=script&lang=js&"
import style0 from "./AwardBanner.vue?vue&type=style&index=0&id=6f94df5c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f94df5c')) {
      api.createRecord('6f94df5c', component.options)
    } else {
      api.reload('6f94df5c', component.options)
    }
    module.hot.accept("./AwardBanner.vue?vue&type=template&id=6f94df5c&", function () {
      api.rerender('6f94df5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Award/components/common/AwardBanner.vue"
export default component.exports